import Reflux from 'reflux';

import { singletonActions } from 'logic/singleton';

const CustomersActions = singletonActions('Customers', () => Reflux.createActions({
  listCustomers: { asyncResult: true },
  load: { asyncResult: true },
  get: { asyncResult: true },
  remove: { asyncResult: true },
  pause: { asyncResult: true },
  resume: { asyncResult: true },
  cloneStream: { asyncResult: true },
  update: { asyncResult: true },
  save: { asyncResult: true },
  removeOutput: { asyncResult: true },
  addOutput: { asyncResult: true },
  testMatch: { asyncResult: true },
}));

export default CustomersActions;
